/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RoleGrant,
  RoleGrant$Outbound,
  RoleGrant$outboundSchema,
} from "./rolegrant.js";

export type CreateRoleForm = {
  /**
   * Optional agent IDs to assign to this role on creation. Scopes an agent cannot hold at runtime are simply not granted to it.
   */
  agentIds?: Array<string> | undefined;
  /**
   * Optional description of what this role can do.
   */
  description?: string | undefined;
  /**
   * Scope grants to assign.
   */
  grants: Array<RoleGrant>;
  /**
   * Optional member IDs to additionally assign to this role on creation.
   */
  memberIds?: Array<string> | undefined;
  /**
   * Display name for the role.
   */
  name: string;
};

/** @internal */
export type CreateRoleForm$Outbound = {
  agent_ids?: Array<string> | undefined;
  description?: string | undefined;
  grants: Array<RoleGrant$Outbound>;
  member_ids?: Array<string> | undefined;
  name: string;
};

/** @internal */
export const CreateRoleForm$outboundSchema: z.ZodMiniType<
  CreateRoleForm$Outbound,
  CreateRoleForm
> = z.pipe(
  z.object({
    agentIds: z.optional(z.array(z.string())),
    description: z.optional(z.string()),
    grants: z.array(RoleGrant$outboundSchema),
    memberIds: z.optional(z.array(z.string())),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentIds: "agent_ids",
      memberIds: "member_ids",
    });
  }),
);

export function createRoleFormToJSON(createRoleForm: CreateRoleForm): string {
  return JSON.stringify(CreateRoleForm$outboundSchema.parse(createRoleForm));
}
